import { ajax }from 'rxjs/ajax';
import { map } from 'rxjs/operators';

export function getResins(manufacturer) {
  const url = manufacturer
    ? `${process.env.PUBLIC_URL}/db/resins.json?host=${manufacturer}`
    : `${process.env.PUBLIC_URL}/db/resins.json`;

  return ajax(url)
    // TODO: not need this once server side to filtering ready
    .pipe(
      map(response =>
        manufacturer 
        ? response.response.items.filter(item =>
            item.manufacturer.toLowerCase() === manufacturer.toLowerCase()
          )
        : response.response.items
      )
    );
}

export default { getResins };



// WEBPACK FOOTER //
// ./src/services/resins.js